import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { planetsApi } from '../api/planets';
import { useToastStore } from '../stores/toastStore';
import { soundEngine } from '../lib/soundEngine';

export function usePlanet() {
  return useQuery({
    queryKey: ['planet', 'me'],
    queryFn: () => planetsApi.getMe(),
    staleTime: 5000,
    refetchInterval: 15000,
  });
}

export function usePurchase(planetId: string) {
  const queryClient = useQueryClient();
  const addToast = useToastStore((s) => s.addToast);

  return useMutation({
    mutationFn: (upgradeDefinitionId: string) =>
      planetsApi.purchase(planetId, upgradeDefinitionId),
    onSuccess: () => {
      soundEngine.playPurchaseChime();
      queryClient.invalidateQueries({ queryKey: ['planet', 'me'] });
      queryClient.invalidateQueries({ queryKey: ['shop', 'upgrades'] });
      queryClient.invalidateQueries({ queryKey: ['credits', 'transactions'] });
      addToast('Upgrade purchased successfully!', 'success');
    },
    onError: (error: any) => {
      soundEngine.playErrorBuzz();
      const msg = error.response?.data?.error?.message || 'Purchase failed';
      addToast(msg, 'error');
    },
  });
}

export function useEmergencyBoost(planetId: string) {
  const queryClient = useQueryClient();
  const addToast = useToastStore((s) => s.addToast);

  return useMutation({
    mutationFn: ({ stat, amount }: { stat: string; amount: number }) =>
      planetsApi.emergencyBoost(planetId, stat, amount),
    onSuccess: (data) => {
      soundEngine.playPurchaseChime();
      queryClient.invalidateQueries({ queryKey: ['planet', 'me'] });
      queryClient.invalidateQueries({ queryKey: ['credits', 'transactions'] });
      const d = data.data;
      addToast(`Emergency boost: +${d?.amount} ${d?.stat} for ${d?.cost}cr`, 'success');
    },
    onError: (error: any) => {
      soundEngine.playErrorBuzz();
      const msg = error.response?.data?.error?.message || 'Emergency boost failed';
      addToast(msg, 'error');
    },
  });
}
